import React, { useEffect, useRef, useState } from "react"
import { fetchSeatsIoEvent, linkTicket, unlinkTicket } from "../../../../../_common/core/http_services/seatsio"
import Select from "../../../../_library/Select"
import Button from "../../../../_library/Button"
import SortableTable from "../../../../_library/SortableTable"
import { getTableColumns } from "../../../../utils/sortableTableUtils"
import { Form, Formik } from "formik"
import { showAxiosError, showSuccessMessage } from "../../../../utils/messenger"

export const SeatsIoTicketManager = ({ eventId, tickets, eventData, fetchSeatData, tables }) => {
  const [data, setData] = useState(null)
  useEffect(() => {
    const seatsIoData = async () => {
      const response = await fetchSeatsIoEvent(eventId)
      setData(response)
    }
    seatsIoData()
  }, [eventId])
  const categoryOptions = data?.categories.map(data => ({
    value: data.key,
    label: `${data.label} (Category: ${data.key})`,
  })) ?? []
  categoryOptions.unshift({
    value: "",
    label: "Select a category",
  })
  const ticketOptions = tickets?.map?.(data => ({
    value: data.id,
    label: data.name,
  })) ?? []
  ticketOptions.unshift({
    value: "",
    label: "Select a Ticket Type",
  })
  const tableOptions = tables?.map?.(data => ({
    value: data.id,
    label: data.name,
  })) ?? []
  const tableOrdersColumns = useRef(getTableColumns([
    {
      label: 'ID',
      key: 'id',
    },
    {
      label: 'Name',
      key: 'name',
    },
  ]))
  return <div className="seats-io-ticket-manager">
    {
      eventData.ticketTypes.map(ticketType => {
        const data = ticketType.ticketTypes.map(ticket => ({
          id: ticket.ticketType,
          name: ticket.label,
        }))
        return <div key={ticketType.category} style={{ padding: 10 }}>
          <div className="section-title-sytle">
            <label>Category: {ticketType.category}</label>
          </div>
          <div className="div-spacing-20" />
          <div>
            <SortableTable
              data={data}
              tableColumns={tableOrdersColumns.current}
              enableSort={false}
              enableCopyTable={false}
              disableMobileView={true}
              className="child-table"
              actionsLabel="Actions"
              actions={
                [
                  {
                    label: 'Unlink Ticket',
                    className: 'btn btn-danger',
                    icon: (
                      <img
                        className="default-icosize"
                        src={asset('/resources/images/cross-ico.svg')}
                        alt=""
                      />
                    ),
                    onClick: async data => {
                      try {
                        await unlinkTicket({
                          eventId,
                          ticketTypeId: data.id,
                          categoryKey: ticketType.category,
                        })
                        showSuccessMessage("Ticket unlinked successfully!")
                        await fetchSeatData(eventId)
                      } catch(e) {
                        showAxiosError(e)
                      }
                    },
                  },
                ]
              }
            />
          </div>
        </div>
      })
    }
    <Formik
      initialValues={{
        ticket_type: "",
        category: "",
      }}
      validate={(values, props) => {
        const errors = {}
        if (!values.category) {
          errors.category = "Required"
        }
        if (!values.ticket_type) {
          errors.ticket_type = "Required"
        }
        return errors
      }}
      onSubmit={async (values) => {
        try {
          await linkTicket({
            eventId,
            ticketTypeId: values.ticket_type,
            categoryKey: values.category,
          })
          showSuccessMessage("Ticket linked successfully!")
          await fetchSeatData(eventId)
        } catch(e) {
          showAxiosError(e?.message)
        }
      }}
    >
      {({ values, errors, setFieldValue }) => (
        <Form>
          <div className="section-title-sytle">
            <label>Link Ticket Type</label>
          </div>
          <div className="col-xs-6 col-12">
            <Select
              id="category"
              label={'Category'}
              options={categoryOptions}
              value={values.category}
              error={errors.category}
              touched={!!errors.category}
              onChange={e => {
                setFieldValue("category", e.target.value)
              }}
            />
          </div>
          <div className="col-xs-6 col-12">
            <Select
              id={'ticket_type'}
              label="Ticket Type"
              options={[...ticketOptions, ...tableOptions]}
              value={values.ticket_type}
              error={errors.ticket_type}
              touched={!!errors.ticket_type}
              onChange={e => {
                setFieldValue("ticket_type", e.target.value)
              }}
            />
          </div>
          <Button
            className="btn btn-primary btn-shadow"
            type="submit"
          >
            <span>Link Ticket</span>
          </Button>
          <div className="div-spacing-20" />
        </Form>
      )}
    </Formik>
  </div>
}

